import React from 'react';

import {
  Button,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphText = ({ id, entity, wide }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);

  const primaryLink = {
    url: entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'])),
    title: entity.getIn(['field_link', 0, 'title']),
    target: entity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self'),
  };

  const secondaryLink = {
    url: entity.getIn(['field_link_secondary', 0, 'alias'], entity.getIn(['field_link_secondary', 0, 'uri'], null)),
    title: entity.getIn(['field_link_secondary', 0, 'title']),
    target: entity.getIn(['field_link_secondary', 0, 'options', 'attributes', 'target'], '_self'),
  };

  return (
    <Container id={id} className="Paragraph ParagraphText">
      <div className="row">
        <div className={`ParagraphText__inner col-12 ${!wide && 'col-md-10 col-lg-8'}`}>
          {title && <h2 className="ParagraphText__title">{title}</h2>}
          <WysiwygField
            property="schema:text"
            className="ParagraphText__body"
            html={body}
          />
          <div className="ParagraphText__links">
            {primaryLink.url && primaryLink.title && (
              <div className="ParagraphText__inline">
                <Button
                  className={`${!secondaryLink.url && 'ParagraphText__link'}`}
                  href={primaryLink.url}
                  target={primaryLink.target}
                  primary={secondaryLink.url && secondaryLink.title}
                >
                  {primaryLink.title}
                  {!secondaryLink.url && <div className="icon icon-arrow-right icon-variant-2" />}
                </Button>
              </div>
            )}
            {secondaryLink.url && secondaryLink.title && (
              <div className="ParagraphText__inline">
                <Button
                  className="ParagraphText__link secondary-action"
                  href={secondaryLink.url}
                  target={secondaryLink.target}
                  primary={false}
                >
                  {secondaryLink.title}
                  <div className="icon icon-arrow-right icon-variant-2" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphText;
